export default __webpack_public_path__ + "3df2b305bf1b9030625ca78ca712f7bc.svg";